export default {
  title: 'Vue CRUD',
  login: 'E-Mail',
  username: 'Username',
  password: 'Passwort',
  failed: 'Einloggen fehlgeschlagen',
  submit: 'Senden',
  passwordRequired: 'Passwort darf nicht leer sein',
  incorrectPassword: 'Passwort ist falsch',
  loginRequired: 'E-Mail darf nicht leer sein',
  incorrectLogin: 'E-Mail ist falsch',
}
